import { useState, useRef, useCallback } from 'react'

export function useDropdown() {
  const [isOpen, setIsOpen] = useState(false)
  const containerRef = useRef<HTMLDivElement>(null)

  const open = useCallback(() => setIsOpen(true), [])
  const close = useCallback(() => setIsOpen(false), [])
  const toggle = useCallback(() => setIsOpen((prev) => !prev), [])

  const handleBlur = useCallback(
    (event: React.FocusEvent) => {
      // Check if the new focus target is still within our component
      if (
        containerRef.current &&
        !containerRef.current.contains(event.relatedTarget as Node)
      ) {
        close()
      }
    },
    [close]
  )

  const handleKeyDown = useCallback(
    (event: React.KeyboardEvent) => {
      if (event.key === 'Escape') {
        close()
      }
    },
    [close]
  )

  return {
    isOpen,
    containerRef,
    open,
    close,
    toggle,
    handleBlur,
    handleKeyDown,
    containerProps: {
      ref: containerRef,
      onBlur: handleBlur,
      onKeyDown: handleKeyDown,
    },
  }
}
